import React, { useCallback, useMemo } from "react";

import { HubHookFormTagInput } from "../HubHookFormTagInput";
import { HubHookFormSelect } from "../HubHookFormSelect";
import { useStationListWithCache } from "./useStationListWithCache";

export const StationHookFormSelect = ({
  name = "stationId",
  label = "Station",
  hideLabel = false,
  required = true,
  disabled = false,
  department,
  status,
  customFilter,
  multiple = false,
  defaultValue,
  ...rest
}) => {
  const { stations, isLoading } = useStationListWithCache();

  const filterFunction = useCallback(
    customFilter
      ? (o) => customFilter(o)
      : (o) => {
          const departmentMatch = department
            ? o.department.id === department
            : true;
          const statusMatch = status ? o.status === status : true;
          return departmentMatch && statusMatch;
        },
    [customFilter, department, status]
  );

  const filtered =
    customFilter || department || status
      ? stations.filter(filterFunction)
      : stations;

  const FieldComponent = useMemo(
    () => (multiple ? HubHookFormTagInput : HubHookFormSelect),
    [multiple]
  );

  const list = useMemo(() => filtered || [], [filtered]);

  return (
    <FieldComponent
      name={name}
      options={list}
      required={required}
      disabled={disabled || isLoading}
      defaultValue={defaultValue}
      MenuProps={{
        sx: {
          "& .MuiMenu-paper": {
            maxHeight: "400px",
          },
          "& .MuiMenu-list": {
            // maxHeight: "254px",
            ".MuiPaper-root": {
              marginTop: "0 !important",
              boxShadow: "none !important",
              border: "0 !important",
              borderRadius: "0px !important",
            },
          },
        },
      }}
      {...(!hideLabel ? { label } : {})}
      {...rest}
    />
  );
};

export default StationHookFormSelect;
